export default "__VITE_ASSET__BYXkUVc___"